export default __webpack_public_path__ + "static/media/minus.aab2bef2.svg";